<template>
  <div class="dashboard-view-container">
    <el-card>
      <template #header>
        <span>{{ $t('message.dashboardMsg.dashboardName') }}</span>  
      </template>
      <div>
        <h3>{{ $t('message.dashboardMsg.welcomingSpeech') }}</h3>
        <p>{{ $t('message.dashboardMsg.currentTime') }}: {{ formattedTime || t('message.common.loading') }}</p>
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, computed } from 'vue'
import { useI18n } from 'vue-i18n'


const { t } = useI18n()
const currentTime = ref(new Date())
const timer = ref(null)

const formattedTime = computed(() => {
  try {
    return currentTime.value.toLocaleString(t('message.dashboardMsg.locale') || navigator.language || 'en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    })
  } catch (error) {    
    return currentTime.value.toString() // 返回默认格式的时间字符串
  }
})

onMounted(() => {
  timer.value = setInterval(() => {
    currentTime.value = new Date()
  }, 1000)
})

onBeforeUnmount(() => {
  if (timer.value) {
    clearInterval(timer.value)
  }
})
</script>

<style scoped>
.dashboard-view-container {
  padding: 20px;
}
</style>